import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { container } from '@Container';
import { TYPES } from '@Types';
import { ArsenalUnitAction } from '@Redux/actions';
import Loader from '@Components/utils/loader/loader.component';
import Repeater from '@Utils/Repeater';
import {
  AvailableUnitCategoryView,
  AvailableUnitView
} from '@Selectors/builder/myArmyList/make/unit/new/view/AvailableUnitCategoryView';
import { UnitRow } from './create-army-list-unit.component.styled';
import { ArsenalUnitNewPresenter } from '@Selectors/arsenal/make/new/arsenal-unit.new.presenter';

const CreateArsenalUnit: React.FC<Props> = ({
                                              datas,
                                              createUnit
                                            }) => {

  if (datas.isLoading) {
    return (<Loader />);
  }

  return (
    <>
      <Repeater data={datas.units} indexPrefix="category">
        {
          (item: AvailableUnitCategoryView) => (
            <div>
              <Repeater data={item.options} indexPrefix="unit">
                {
                  (unit: AvailableUnitView) => (
                    <UnitRow>
                      <div className="py-3 px-2 p-md-1" onClick={() => createUnit(unit)}>
                        <i className="fa-solid fa-plus"></i>
                        <span className="name ms-1">{unit.name}</span>
                      </div>
                    </UnitRow>
                  )
                }
              </Repeater>
            </div>
          )
        }
      </Repeater>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  datas: ArsenalUnitNewPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const unitAction = container.get<ArsenalUnitAction>(TYPES.Actions.ArsenalUnitAction);
  return {
    createUnit: (unit: AvailableUnitView) => {
      dispatch(unitAction.create(unit));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateArsenalUnit);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
